import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { OfflineBanner } from "./OfflineBanner";
import { Sidebar } from "./Sidebar";

export const Layout = () => {
	return (
		<div className="flex h-full min-h-0 min-w-0 flex-1 bg-bg-page">
			<Sidebar />
			<div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
				<Header />
				<OfflineBanner />
				<main className="min-h-0 min-w-0 flex-1 overflow-y-auto overflow-x-hidden px-6 pt-6 pb-6">
					<Outlet />
				</main>
			</div>
		</div>
	);
};
